import { render, staticRenderFns } from "./VeJwJingsaiProjectList.vue?vue&type=template&id=a9d453fa&scoped=true"
import script from "./VeJwJingsaiProjectList.vue?vue&type=script&lang=js"
export * from "./VeJwJingsaiProjectList.vue?vue&type=script&lang=js"
import style0 from "./VeJwJingsaiProjectList.vue?vue&type=style&index=0&id=a9d453fa&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9d453fa",
  null
  
)

export default component.exports